import { render } from "./VerifyTwoFa.vue?vue&type=template&id=b9775bb4&scoped=true"
import script from "./VerifyTwoFa.vue?vue&type=script&lang=js"
export * from "./VerifyTwoFa.vue?vue&type=script&lang=js"

import "./VerifyTwoFa.vue?vue&type=style&index=0&id=b9775bb4&lang=less&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9775bb4"]])

export default __exports__